import i18n from "../i8n";

/* Los nombres de zona se leen del fichero de idiomas (zones.1, zones.2...).
   Son getters para que siempre salgan en el idioma activo. */
const nombreZona = (value) => i18n.t(`zones.${value}`);
const CODIGOS = ["1", "2", "3"];

export const ZONE_OPTIONS = CODIGOS.map((value) => ({
    value,
    get label() {
        return nombreZona(value);
    },
}));

/* Listas indexadas por código de zona (ZONE_LABEL_MAP) o empezando en 0
   (ZONE_LABEL_MAP_ZERO), con el nombre traducido en cada posición. */
const listaTraducida = (desplazamiento) => {
    const lista = new Array(CODIGOS.length + desplazamiento).fill(undefined);
    CODIGOS.forEach((value, i) => {
        Object.defineProperty(lista, i + desplazamiento, {
            get: () => nombreZona(value),
            enumerable: true,
        });
    });
    return lista;
};

export const ZONE_LABEL_MAP = listaTraducida(1);

export const ZONE_LABEL_MAP_ZERO = listaTraducida(0);
